import { useEffect, useState } from "react";

const FilePreview = ({ item, setIsDetail = null }) => {
  const [previewPath, setPreviewPath] = useState("");

  useEffect(() => {
    if (!item) return;

    const path = typeof item === "string" ? item : item.path;
    if (!path) return;

    const isBase64 = path.startsWith("data:image/") || path.startsWith("data:video/");
    setPreviewPath(isBase64 ? path : imgHandler(path));
  }, [item]);

  if (!item || !previewPath) return null;

  const file = typeof item === "object" ? item.file : null;
  const isBlob = previewPath.startsWith("blob:");
  const isBase64 = previewPath.startsWith("data:");

  const isImage =
    isBlob || isBase64
      ? file?.type?.startsWith("image/") || previewPath.startsWith("data:image/")
      : /\.(jpg|jpeg|png|gif|bmp|webp|svg|ico|tiff|tif|heic|heif)$/i.test(previewPath);

  const isVideo =
    isBlob || isBase64
      ? file?.type?.startsWith("video/") || previewPath.startsWith("data:video/")
      : /\.(mp4|webm|ogg)$/i.test(previewPath);

  return (
    <>
      {isImage ? (
        <img
          src={previewPath}
          alt="uploaded preview"
          onDragStart={(e) => e.preventDefault()}
          onClick={() => setIsDetail && setIsDetail(true)}
          onError={onErrorImg}
        />
      ) : isVideo ? (
        <video autoPlay muted controls>
          <source src={previewPath} type={file?.type || "video/mp4"} />
        </video>
      ) : null}
    </>
  );
};

export default FilePreview;
